import { render } from "./AIBrief.vue?vue&type=template&id=33b5e25c"
import script from "./AIBrief.vue?vue&type=script&lang=js"
export * from "./AIBrief.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__